(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["big-pack-navigation"]) return;
  try {
    
(()=>{const groups=document.querySelectorAll('.bp-nav-group');function close(group,focus){const b=group.querySelector('button');b.setAttribute('aria-expanded','false');group.querySelector('.bp-submenu').hidden=true;if(focus)b.focus();}groups.forEach(group=>{const b=group.querySelector('button'),panel=group.querySelector('.bp-submenu');b.addEventListener('click',()=>{const open=b.getAttribute('aria-expanded')==='true';groups.forEach(g=>close(g,false));b.setAttribute('aria-expanded',String(!open));panel.hidden=open;});group.addEventListener('focusout',e=>{if(!group.contains(e.relatedTarget))close(group,false);});group.addEventListener('keydown',e=>{if(e.key==='Escape'){close(group,true);e.preventDefault();}});});document.addEventListener('click',e=>{groups.forEach(g=>{if(!g.contains(e.target))close(g,false);});document.querySelectorAll('.bp-mobile-menu[open]').forEach(m=>{if(!m.contains(e.target)||e.target.closest('a'))m.open=false;});});document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.bp-mobile-menu[open]').forEach(m=>{m.open=false;m.querySelector('summary').focus();});});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["big-pack-page"]) return;
  try {
    
(()=>{function init(section){const quiz=section.querySelector('[data-bp-quiz]'),slot=section.querySelector('[data-bp-quiz-slot]');if(!quiz||!slot||quiz.dataset.ready)return;quiz.dataset.ready='true';slot.replaceWith(quiz);quiz.hidden=false;const config=JSON.parse(section.querySelector('[data-quiz-config]').textContent),questions=config.questions.map(q=>JSON.parse(q));let index=0,score=0,answered=false;const el=s=>quiz.querySelector(s),feedback=el('[data-feedback]'),next=el('[data-next]'),restart=el('[data-restart]');function render(){answered=false;const q=questions[index];el('[data-progress]').textContent=(index+1)+' / '+questions.length;el('progress').value=index;el('[data-title]').textContent=q.title;el('legend').textContent=q.question;feedback.textContent='';next.hidden=true;restart.hidden=true;el('fieldset').hidden=false;el('[data-options]').replaceChildren(...q.answers.map((answer,i)=>{const b=document.createElement('button');b.type='button';b.textContent=answer;b.setAttribute('aria-pressed','false');b.addEventListener('click',()=>{if(answered)return;answered=true;if(i===q.correct)score++;b.setAttribute('aria-pressed','true');el('[data-options]').querySelectorAll('button').forEach(x=>x.disabled=true);feedback.textContent=(i===q.correct?config.correct:config.learn)+' '+q.explanation;next.hidden=false;el('progress').value=index+1;next.focus({preventScroll:true})});return b}));}next.addEventListener('click',()=>{index++;if(index<questions.length){render();el('legend').focus({preventScroll:true})}else{el('fieldset').hidden=true;el('[data-title]').textContent=config.complete;el('[data-progress]').textContent=score+' / '+questions.length;feedback.textContent=config.finish;next.hidden=true;restart.hidden=false;restart.focus({preventScroll:true})}});restart.addEventListener('click',()=>{index=0;score=0;render();el('legend').focus({preventScroll:true})});render();}document.querySelectorAll('[data-bp-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bp-page]').forEach(init));})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-vault"] && !Shopify.designMode) return;
  try {
    

(()=>{
  const initialize=root=>{
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    const config=JSON.parse(root.querySelector('[data-vault-config]').textContent);
    const stage=root.querySelector('.pv-stage'),pack=stage.querySelector('.pv-pack'),target=stage.querySelector('.pv-rip-target'),reveal=stage.querySelector('.pv-reveal'),replay=stage.querySelector('.pv-again'),status=root.querySelector('.pv-status');
    let opened=false,startX=null,distance=0,lastPokemon=-1,nextPokemon,revealTimer;
    const shell=document.createElement('div');shell.className='pv-pack-shell';pack.before(shell);shell.append(pack);shell.append(pack.querySelector('.pv-tear'));const emerging=document.createElement('div');emerging.className='pv-emerging';emerging.setAttribute('aria-hidden','true');shell.prepend(emerging);
    const pool=config.pokemon;
    function prepare(){const choices=pool.filter(p=>p.id!==lastPokemon);nextPokemon=choices[Math.floor(Math.random()*choices.length)];const preload=new Image();preload.src=nextPokemon.url;}
    function populate(){const p=nextPokemon;lastPokemon=p.id;const set=(key,value)=>reveal.querySelector('[data-dex-'+key+']').textContent=value;set('number','#'+String(p.id).padStart(4,'0'));set('name',p.name);set('class',p.category);set('height',p.height);set('weight',p.weight);set('abilities',p.abilities);set('fact',p.fact);const img=new Image(160,160);img.src=p.url;img.alt=p.name;img.decoding='async';reveal.querySelector('[data-dex-art]').replaceChildren(img);reveal.querySelector('[data-dex-types]').replaceChildren(...p.types.map(t=>{const badge=document.createElement('span');badge.textContent=t;return badge}));return p;}
    prepare();
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');

    let packyIndex=Math.floor(Math.random()*3);
    const showPacky=()=>{stage.dataset.packy=String(packyIndex);};
    const nextPacky=()=>{packyIndex=(packyIndex+1)%3;showPacky();};
    showPacky();
    const packyTimer=setInterval(()=>{if(!root.isConnected){clearInterval(packyTimer);return;}if(!reduced.matches&&!opened&&!document.hidden)nextPacky();},6000);

    function rip(){if(opened)return;const pokemon=populate();opened=true;target.disabled=true;target.setAttribute('aria-expanded','true');const sprite=new Image(220,220);sprite.src=pokemon.url;sprite.alt='';emerging.replaceChildren(sprite);stage.classList.add('pv-opening');const finish=()=>{stage.classList.remove('pv-opening');stage.classList.add('pv-ripped');reveal.hidden=false;reveal.inert=false;replay.hidden=false;status.textContent=pokemon.name+'. '+config.text.opened;reveal.focus({preventScroll:true});};if(reduced.matches)finish();else revealTimer=setTimeout(finish,2100);} 
    function reset(){nextPacky();opened=false;clearTimeout(revealTimer);stage.classList.remove('pv-ripped','pv-opening');stage.style.setProperty('--tear',0);target.disabled=false;target.setAttribute('aria-expanded','false');reveal.inert=true;reveal.hidden=true;replay.hidden=true;prepare();status.textContent=config.text.closed;target.focus({preventScroll:true});}
    target.addEventListener('pointerdown',e=>{startX=e.clientX;distance=0;target.setPointerCapture(e.pointerId)});
    target.addEventListener('pointermove',e=>{if(startX===null||opened)return;distance=Math.max(0,e.clientX-startX);stage.style.setProperty('--tear',Math.min(distance/100,1));if(distance>90){startX=null;rip()}});
    target.addEventListener('pointerup',()=>{startX=null;if(distance>40)rip();else stage.style.setProperty('--tear',0)});
    target.addEventListener('pointercancel',()=>{startX=null;stage.style.setProperty('--tear',0)});
    target.addEventListener('click',rip);replay.addEventListener('click',reset);
    root.querySelectorAll('[data-rip]').forEach(b=>b.addEventListener('click',rip));
    root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('[data-kind]').forEach(x=>{x.hidden=b.dataset.filter!=='all'&&x.dataset.kind!==b.dataset.filter})}));
    root.querySelectorAll('[data-visit]').forEach(b=>b.addEventListener('click',()=>root.querySelector('#pv-visit-info').scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'})));

    const showcaseCleanups=[];
    root.querySelectorAll('[data-showcase]').forEach((card,cardIndex)=>{
      const live=card.querySelector('[data-showcase-live]'),liveItems=live?JSON.parse(live.textContent):[];
      const items=liveItems.length?liveItems:JSON.parse(card.querySelector('[data-showcase-items]').textContent),image=card.querySelector('[data-showcase-image]'),pause=card.querySelector('[data-showcase-pause]');
      if(liveItems.length){image.src=items[0].url;image.alt=items[0].name;card.querySelector('[data-showcase-name]').textContent=items[0].name;card.querySelector('[data-showcase-detail]').textContent=items[0].detail;card.querySelector('.pv-showcase-art').href=items[0].href;card.querySelector('[data-showcase-count]').textContent='1 / '+items.length;}
      if(items.length<2)return;
      let index=0,paused=reduced.matches,hovered=false,focused=false,visible=false,timer=null,request=0;
      card.querySelector('.pv-showcase-controls').hidden=false;
      const stop=()=>{clearTimeout(timer);timer=null;};
      const syncButton=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);};
      const schedule=()=>{stop();if(!paused&&!hovered&&!focused&&visible&&!document.hidden&&!card.hidden)timer=setTimeout(()=>show(index+1),5200+cardIndex*650);};
      function show(next){const selected=(next+items.length)%items.length,entry=items[selected],token=++request;stop();const preload=new Image();preload.onload=()=>{if(token!==request||!card.isConnected)return;index=selected;image.src=entry.url;image.alt=entry.name;if(entry.href)card.querySelector('.pv-showcase-art').href=entry.href;image.classList.remove('pv-photo-enter');void image.offsetWidth;if(!reduced.matches)image.classList.add('pv-photo-enter');card.querySelector('[data-showcase-name]').textContent=entry.name;card.querySelector('[data-showcase-detail]').textContent=entry.detail;card.querySelector('[data-showcase-count]').textContent=(index+1)+' / '+items.length;schedule();};preload.onerror=()=>{if(token===request)schedule();};preload.src=entry.url;}
      card.querySelector('[data-showcase-prev]').addEventListener('click',()=>show(index-1));
      card.querySelector('[data-showcase-next]').addEventListener('click',()=>show(index+1));
      pause.addEventListener('click',()=>{paused=!paused;syncButton();schedule();});
      card.addEventListener('mouseenter',()=>{hovered=true;stop();});card.addEventListener('mouseleave',()=>{hovered=false;schedule();});
      card.addEventListener('focusin',()=>{focused=true;stop();});card.addEventListener('focusout',e=>{if(!card.contains(e.relatedTarget)){focused=false;schedule();}});
      const visibility=()=>schedule(),motion=()=>{paused=reduced.matches;syncButton();schedule();};
      document.addEventListener('visibilitychange',visibility);reduced.addEventListener('change',motion);
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15});observer.observe(card);
      const hiddenObserver=new MutationObserver(schedule);hiddenObserver.observe(card,{attributes:true,attributeFilter:['hidden']});
      syncButton();showcaseCleanups.push(()=>{stop();request++;observer.disconnect();hiddenObserver.disconnect();document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',motion);});
    });
    const sections=[...root.querySelectorAll('.pv-hero,.pv-section,.pv-feature,.pv-events,.pv-location')];
    const layers=sections.map(s=>{s.classList.add('pv-scene');const layer=document.createElement('div');layer.className='pv-background';layer.setAttribute('aria-hidden','true');const img=document.createElement('img');img.alt='';img.width=475;img.height=475;img.decoding='async';img.loading=s.classList.contains('pv-hero')?'eager':'lazy';layer.append(img);s.append(layer);return img});
    let current=-1;
    function choose(){let last=current;try{if(last<0)last=Number(sessionStorage.getItem('big-pack-encounter')??-1)}catch{}const options=config.themes.map((_,i)=>i).filter(i=>i!==last);current=options[Math.floor(Math.random()*options.length)];try{sessionStorage.setItem('big-pack-encounter',String(current))}catch{}const t=config.themes[current];layers.forEach((img,i)=>{const n=Math.min(t.members.length-1,Math.floor(i*t.members.length/sections.length));img.src=t.members[n].url;sections[i].style.setProperty('--scene-wash',['#e8f5e8','#fff1df','#e6f2fa'][current%3]);sections[i].dataset.encounter=t.members[n].name});root.querySelector('.pv-themed-path').textContent=t.members.map(x=>x.name).join(' → ')}
    root.querySelector('[data-encounter]').addEventListener('click',choose);choose();
    let raf=0;const drift=()=>{raf=0;if(reduced.matches)return;sections.forEach(s=>{const b=s.getBoundingClientRect();if(b.bottom>0&&b.top<innerHeight)s.style.setProperty('--pv-drift',Math.max(-22,Math.min(22,(innerHeight/2-b.top-b.height/2)*.04))+'px')})};
    const onScroll=()=>{if(!raf)raf=requestAnimationFrame(drift)};addEventListener('scroll',onScroll,{passive:true});
    const unload=e=>{if(!e.target.contains(root))return;clearTimeout(revealTimer);showcaseCleanups.forEach(cleanup=>cleanup());removeEventListener('scroll',onScroll);if(raf)cancelAnimationFrame(raf);document.removeEventListener('shopify:section:unload',unload)};document.addEventListener('shopify:section:unload',unload);
  };
  document.querySelectorAll('[data-pack-vault]').forEach(initialize);
  document.addEventListener('shopify:section:load',e=>initialize(e.target.querySelector('[data-pack-vault]')));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
